/* Rising Sun FPV - Robot Arena mini-game (draft).
   Build an antweight inside the weight limit, fight an AI bot in a top-down arena, then see the matching
   real parts from the store's own /collections/<handle>/products.json feed. The section renders the copy
   and markup; this file holds the numbers and behaviour. Vanilla JS, no storage, nothing autoplays. */
(function () {
  'use strict';
  /* the section can be on a page twice, so this file can load twice: set up once */
  if (window.RSArena) { window.RSArena.init(document); return; }
  var d = document, M = Math, PI = M.PI, TAU = PI * 2;
  var W = 600, R = 28, WALL = 16, STEP = 1 / 120;
  var PX = 300, PY = 196, PS = 116; /* pit centre and size, arena units */
  var KMH = 0.0144; /* 1 arena unit = 4 mm */
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function calm() { return mq.matches; }
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function angDiff(a, b) { var x = (a - b) % TAU; if (x > PI) x -= TAU; if (x < -PI) x += TAU; return x; }
  function mmss(s) { s = M.max(0, M.ceil(s)); var m = s / 60 | 0; s %= 60; return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s; }

  /* ------------------------------------------------------------------ parts, opponents, difficulty
     Weights (g) are plausible antweight numbers, tuned so trade-offs matter under a 150 g limit.
     Every weapon + armour pair still fits: bar spinner + thick TPU is 149 g on 2WD with the small pack. */
  var CONTROL_G = 8;
  var PARTS = {
    drive: [
      { id: 'fast', w: 24, spd: 1, push: 0.42, grip: 0.55, draw: 1, n: 2, rpm: 1000 },
      { id: 'torque', w: 24, spd: 0.6, push: 0.85, grip: 0.75, draw: 0.9, n: 2, rpm: 300 },
      { id: 'awd', w: 46, spd: 0.76, push: 1, grip: 1, draw: 1.5, n: 4, rpm: 600 }
    ],
    weapon: [
      { id: 'wedge', w: 0, punch: 0.12, draw: 0 },
      { id: 'lifter', w: 22, punch: 0.5, draw: 0.2 },
      { id: 'bar', w: 48, punch: 1, draw: 1.2 },
      { id: 'drum', w: 36, punch: 0.7, draw: 0.8 }
    ],
    armour: [
      { id: 'tpu', w: 42, arm: 0.72 },
      { id: 'petg', w: 32, arm: 0.48, brittle: 1 },
      { id: 'thick', w: 58, arm: 1, skirt: 1 }
    ],
    battery: [
      { id: 's2a', w: 11, pow: 0.72, cap: 0.5, cells: 2, mah: 180 },
      { id: 's2b', w: 17, pow: 0.76, cap: 0.85, cells: 2, mah: 300 },
      { id: 's3', w: 24, pow: 1, cap: 0.8, cells: 3, mah: 300 }
    ]
  };
  var SLOTS = ['drive', 'weapon', 'armour', 'battery'];
  var OPPS = [
    { id: 'roadtrain', name: 'Road Train', tag: '4WD wedge pusher', c: '#d9d4c6', c2: '#ff5a4e', b: { drive: 'awd', weapon: 'wedge', armour: 'thick', battery: 's2b' } },
    { id: 'mudcrab', name: 'Mudcrab', tag: 'drum spinner', c: '#ff5a4e', c2: '#1b1e21', b: { drive: 'torque', weapon: 'drum', armour: 'tpu', battery: 's2b' } },
    { id: 'magpie', name: 'Magpie', tag: 'servo flipper', c: '#f4f0e6', c2: '#1b1e21', b: { drive: 'fast', weapon: 'lifter', armour: 'tpu', battery: 's3' } }
  ];
  var YOU = { c: '#ffb000', c2: '#1b1e21' };
  var DIFF = {
    rookie: { react: 0.3, jit: 0.55, thr: 0.72, fire: 0.45, wander: 0.14, pit: 0.4, hunt: 0 },
    veteran: { react: 0.09, jit: 0.14, thr: 1, fire: 0.95, wander: 0.02, pit: 1, hunt: 1 },
    pilot: { react: 0.12, jit: 0.2, thr: 0.95, fire: 0.9, wander: 0.03, pit: 1, hunt: 1 } /* auto-pilot */
  };

  function part(slot, id) { var l = PARTS[slot]; for (var i = 0; i < l.length; i++) if (l[i].id === id) return l[i]; return l[0]; }
  function oppBy(id) { for (var i = 0; i < OPPS.length; i++) if (OPPS[i].id === id) return OPPS[i]; return OPPS[0]; }
  function weightOf(b) { return SLOTS.reduce(function (g, s) { return g + part(s, b[s]).w; }, CONTROL_G); }
  function statsOf(b) {
    var dr = part('drive', b.drive), wp = part('weapon', b.weapon), ar = part('armour', b.armour), bt = part('battery', b.battery), m = weightOf(b);
    return {
      speed: clamp(dr.spd * (0.8 + 0.2 * bt.pow) * (1.14 - m / 500), 0.05, 1),
      push: clamp(dr.push * 0.72 + m / 150 * 0.2 + (wp.id === 'wedge' ? 0.14 : 0) + (ar.skirt ? 0.08 : 0), 0.05, 1),
      punch: clamp(wp.punch * (0.72 + 0.28 * bt.pow), 0.05, 1),
      armour: ar.arm,
      endurance: clamp(bt.cap / (0.55 + 0.25 * dr.draw + 0.3 * wp.draw), 0.05, 1)
    };
  }
  /* the smallest single swaps that bring an over-weight build back under the limit */
  function fixes(b, limit) {
    var over = weightOf(b) - limit, out = [];
    if (over > 0) SLOTS.forEach(function (s) {
      var cur = part(s, b[s]).w;
      PARTS[s].forEach(function (p) { if (cur - p.w >= over) out.push({ slot: s, p: p, save: cur - p.w }); });
    });
    return out.sort(function (x, y) { return x.save - y.save; }).slice(0, 2);
  }
  function allBuilds() {
    var out = [{}];
    SLOTS.forEach(function (s) { out = [].concat.apply([], out.map(function (b) { return PARTS[s].map(function (p) { var c = {}; for (var k in b) c[k] = b[k]; c[s] = p.id; return c; }); })); });
    return out;
  }

  /* ------------------------------------------------------------------ simulation (no DOM, testable headless) */
  function makeBot(b, x, y, a, look, name) {
    var st = statsOf(b), dr = part('drive', b.drive);
    return {
      b: b, name: name, look: look, st: st, m: weightOf(b), dr: dr,
      wp: part('weapon', b.weapon), ar: part('armour', b.armour), bt: part('battery', b.battery),
      x: x, y: y, a: a, vx: 0, vy: 0, w: 0, z: 0, vz: 0, hp: 100, e: 1,
      spin: 0, on: false, cd: 0, arm: 0, hitCd: 0, flash: 0, slide: 0, under: 0, fall: 0, out: false, dead: false,
      thr: 0, turn: 0, phase: 0, hits: 0, dealt: 0, taken: 0, top: 0, last: null, lastT: -9,
      maxV: 110 + 230 * st.speed, turnR: 2.4 + 2.6 * dr.spd, acc: 520 + 760 * dr.grip,
      ai: { t: 0, rev: 0, rt: M.random() < 0.5 ? -1 : 1, stuck: 0, wand: 0, wa: 0, fireT: 0 }
    };
  }
  function newGame(o) {
    var T = o.T || 60, p = makeBot(o.build, 120, 420, 0, YOU, 'You'), e = makeBot(o.opp.b, 480, 420, PI, o.opp, o.opp.name);
    p.me = true;
    return {
      t: 0, T: T, cd: 3, bots: [p, e], diff: DIFF[o.diff] || DIFF.rookie, diffId: o.diff, auto: !!o.auto, oppId: o.opp.id,
      pitAt: M.max(8, T * 0.4), pitWarn: false, pitOpen: false, pitAnim: 0,
      fx: [], txt: [], ev: [], shake: 0, over: null, input: { sx: 0, sy: 0, sm: 0 }
    };
  }
  function power(me) { return me.e > 0.25 ? 1 : 0.45 + 2.2 * me.e; }
  function spinner(me) { return me.wp.id === 'bar' || me.wp.id === 'drum'; }
  function armMul(me) { return 1.15 - 0.5 * me.ar.arm; }
  function inPit(x, y, pad) { return M.abs(x - PX) < PS / 2 + pad && M.abs(y - PY) < PS / 2 + pad; }
  function who(me, you, them) { return me.me ? you : me.name + them; }
  function say(G, s, prio) { G.ev.push({ say: s, prio: prio }); }
  function shake(G, v) { if (!calm()) G.shake = M.max(G.shake, v); }
  function sparks(G, x, y, n, dx, dy, hot) {
    if (calm()) n = M.ceil(n / 2);
    var base = M.atan2(dy, dx);
    if (n > 7) G.fx.push({ k: 3, x: x, y: y, vx: 0, vy: 0, l: 0, m: 0.16, s: 10 + n * 0.8 });
    for (var i = 0; i < n && G.fx.length < 420; i++) {
      var a = base + (M.random() - 0.5) * 2.4, v = 160 + M.random() * 420;
      G.fx.push({ k: 0, x: x, y: y, vx: M.cos(a) * v, vy: M.sin(a) * v, l: 0, m: 0.22 + M.random() * 0.35, c: hot || M.random() < 0.3 ? '#fff4c2' : '#ffb000' });
    }
  }
  function bits(G, x, y, n, c) {
    for (var i = 0; i < n; i++) {
      var a = M.random() * TAU, v = 40 + M.random() * 140;
      G.fx.push({ k: 1, x: x, y: y, vx: M.cos(a) * v, vy: M.sin(a) * v, l: 0, m: 0.7 + M.random() * 0.6, r: M.random() * 3, c: c });
    }
  }
  function hurt(G, me, dmg, by) {
    if (!(dmg > 0.05) || me.dead || me.out || G.over) return;
    if (me.ar.brittle && dmg > 8) {
      dmg *= 1.25;
      if (!me.cracked) { me.cracked = true; say(G, who(me, 'Your', '\u2019s') + ' shell cracks!'); bits(G, me.x, me.y, 8, '#aab2b9'); }
    }
    dmg = M.min(me.hp, dmg);
    me.hp -= dmg; me.taken += dmg; me.flash = 0.14;
    if (by) { by.dealt += dmg; me.last = by; me.lastT = G.t; }
    if (dmg >= 1) G.txt.push({ x: me.x, y: me.y - R - 8, s: '-' + M.round(dmg), l: 0, c: me.me ? '#ff8a80' : '#ffcf5a' });
    if (me.hp <= 0.01) { me.hp = 0; me.dead = true; me.on = false; }
    else if (dmg >= 7) say(G, 'Big hit! ' + who(me, 'Your armour ', ' armour ') + M.round(me.hp) + '%.');
  }
  function flip(G, me, foe) {
    if (me.cd > 0 || me.dead || me.z > 0) return;
    me.cd = 1.8; me.arm = 1;
    var dx = foe.x - me.x, dy = foe.y - me.y, dist = M.hypot(dx, dy) || 1, ca = M.cos(me.a), sa = M.sin(me.a);
    if (foe.out || foe.fall || foe.z > 10 || dist > 2 * R + 14 || (ca * dx + sa * dy) / dist < 0.62) return;
    var e = me.wp.punch * power(me) * 2, fc = -(M.cos(foe.a) * dx + M.sin(foe.a) * dy) / dist;
    if ((foe.wp.id === 'wedge' || foe.ar.skirt) && fc > 0.7 && M.random() < (foe.wp.id === 'wedge' ? 0.5 : 0.3)) { e *= 0.45; say(G, 'The wedge got under first!'); }
    var kb = 250 * e * 130 / foe.m;
    foe.vz = 180 + 170 * e; foe.z = 1;
    foe.vx += ca * kb; foe.vy += sa * kb; foe.w += (M.random() - 0.5) * 10; foe.slide = 0.6; foe.spin *= 0.5;
    me.hits++;
    hurt(G, foe, 3.5 * e * armMul(foe), me);
    sparks(G, me.x + ca * R, me.y + sa * R, 10, ca, sa);
    shake(G, 7);
    if (e > 0.6) say(G, 'Launched! ' + who(foe, 'You go', ' goes') + ' flying.');
  }
  function trigger(G, me, foe) {
    if (me.dead) return;
    if (me.wp.id === 'lifter') flip(G, me, foe);
    else if (spinner(me)) { me.on = !me.on; say(G, me.on ? 'Weapon spinning up.' : 'Weapon powered down.', 1); }
    else say(G, 'Wedges are always armed. Drive into them!', 1);
  }
  function move(G, me, dt) {
    var pw = power(me), air, trac, f, l, ca, sa;
    me.flash = M.max(0, me.flash - dt); me.slide -= dt; me.under -= dt; me.hitCd -= dt; me.cd -= dt;
    me.arm = M.max(0, me.arm - dt * 2.5);
    if (me.fall) {
      me.fall = M.min(1, me.fall + dt / 0.75);
      me.x += (PX - me.x) * M.min(1, dt * 2); me.y += (PY - me.y) * M.min(1, dt * 2); me.a += me.w * dt;
      if (me.fall >= 1) me.out = true;
      return;
    }
    if (me.dead) me.thr = me.turn = 0;
    if (spinner(me)) {
      var rate = (me.wp.id === 'bar' ? 0.42 : 1) * (0.6 + 0.4 * me.bt.pow);
      me.spin = me.on && me.e > 0 ? M.min(pw, me.spin + rate * dt) : M.max(0, me.spin - 0.22 * dt);
      me.phase += me.spin * dt * 40;
    }
    air = me.z > 0;
    trac = air ? 0 : me.under > 0 ? 0.3 : 1;
    me.w += (me.turn * me.turnR * (me.wp.id === 'bar' ? 1 - 0.3 * me.spin : 1) * trac - me.w) * M.min(1, dt * (air ? 0.5 : 12));
    me.a += me.w * dt;
    ca = M.cos(me.a); sa = M.sin(me.a);
    f = me.vx * ca + me.vy * sa; l = -me.vx * sa + me.vy * ca;
    if (!air) {
      var md = me.acc * trac * dt;
      f += clamp(me.thr * me.maxV * pw - f, -md, md);
      if (!me.thr) f *= M.exp(-dt * 2.5);
      l *= M.exp(-dt * (me.slide > 0 ? 1.8 : 7 + 10 * me.dr.grip));
      if (trac === 1 && me.slide <= 0) me.top = M.max(me.top, M.abs(f));
    }
    me.vx = f * ca - l * sa; me.vy = f * sa + l * ca;
    me.x += me.vx * dt; me.y += me.vy * dt;
    if (air || me.vz > 0) {
      me.vz -= 900 * dt; me.z += me.vz * dt;
      if (me.z <= 0) {
        var hit = -me.vz; me.z = 0; me.vz = 0;
        if (hit > 230) { hurt(G, me, (hit - 230) * 0.03 * armMul(me), G.t - me.lastT < 2 ? me.last : null); shake(G, 4); bits(G, me.x, me.y, 3, '#5d656d'); }
      }
    }
    me.e = M.max(0, me.e - dt * (0.25 + 0.45 * M.abs(me.thr) * me.dr.draw + 0.55 * (me.on ? 1 : 0) * me.wp.draw) / (me.bt.cap * G.T * 1.6));
    if (me.me && me.e < 0.2 && !me.lowSaid) { me.lowSaid = true; say(G, 'Your battery is running flat.'); }
    var lo = WALL + R, hi = W - WALL - R;
    if (me.x < lo) wall(G, me, 'x', lo, -1); else if (me.x > hi) wall(G, me, 'x', hi, 1);
    if (me.y < lo) wall(G, me, 'y', lo, -1); else if (me.y > hi) wall(G, me, 'y', hi, 1);
    if (G.pitAnim > 0.6 && !air && inPit(me.x, me.y, -R * 0.35)) {
      me.fall = 0.01; me.on = false; me.w = 3;
      say(G, who(me, 'You drop', ' drops') + ' into the pit!', 1); shake(G, 6);
    }
    if (me.hp < 30 && M.random() < dt * (me.dead ? 14 : 6) && G.fx.length < 420) {
      G.fx.push({ k: 2, x: me.x + (M.random() - 0.5) * 16, y: me.y + (M.random() - 0.5) * 16, vx: 10 - M.random() * 20, vy: -20 - M.random() * 20, l: 0, m: 1.1 + M.random() * 0.6 });
    }
  }
  function wall(G, me, ax, lim, side) {
    var v = ax === 'x' ? me.vx : me.vy, hit = M.abs(v);
    if (ax === 'x') { me.x = lim; me.vx = -v * 0.3; } else { me.y = lim; me.vy = -v * 0.3; }
    if (hit > 170 && v * side > 0) {
      hurt(G, me, (hit - 170) * 0.035 * armMul(me), G.t - me.lastT < 1.5 ? me.last : null);
      var sx = ax === 'x' ? side : 0, sy = ax === 'y' ? side : 0;
      sparks(G, me.x + sx * R, me.y + sy * R, 5 + hit / 45, -sx || M.random() - 0.5, -sy || M.random() - 0.5);
      shake(G, hit / 60);
    }
  }
  /* how hard a robot is to shove: weight, grip, whether its wheels are on the floor, and whether it pushes back */
  function stance(me, nx, ny) {
    var into = M.max(0, me.thr * (M.cos(me.a) * nx + M.sin(me.a) * ny)), trac = me.z > 0 ? 0.08 : me.under > 0 ? 0.3 : 1;
    return me.m * (0.45 + me.dr.grip) * trac * (1 + 1.8 * into * me.st.push);
  }
  function collide(G, a, b, dt) {
    if (a.out || b.out || a.fall || b.fall || M.abs(a.z - b.z) > 26) return;
    var dx = b.x - a.x, dy = b.y - a.y, dist = M.hypot(dx, dy) || 0.01;
    if (dist >= 2 * R) return;
    var nx = dx / dist, ny = dy / dist, ov = 2 * R - dist, sa = stance(a, nx, ny), sb = stance(b, -nx, -ny), tot = sa + sb;
    a.x -= nx * ov * sb / tot; a.y -= ny * ov * sb / tot;
    b.x += nx * ov * sa / tot; b.y += ny * ov * sa / tot;
    var va = a.vx * nx + a.vy * ny, vb = b.vx * nx + b.vy * ny, close = va - vb;
    if (close > 0) {
      var vc = (sa * va + sb * vb) / tot, ja = vc - va - 0.2 * close * sb / tot, jb = vc - vb + 0.2 * close * sa / tot;
      a.vx += ja * nx; a.vy += ja * ny; b.vx += jb * nx; b.vy += jb * ny;
      if (close > 200) { ram(G, a, b, nx, ny, close); ram(G, b, a, -nx, -ny, close); }
    }
    under(G, a, b, nx, ny); under(G, b, a, -nx, -ny);
    pin(G, a, b, nx, ny, dt); pin(G, b, a, -nx, -ny, dt);
  }
  function ram(G, a, b, nx, ny, close) {
    if (M.cos(a.a) * nx + M.sin(a.a) * ny < 0.6 || a.dead) return;
    var dmg = (close - 200) * 0.012 * (a.wp.id === 'wedge' ? 1.6 : 0.5) * a.st.push * armMul(b);
    if (dmg < 0.3) return;
    hurt(G, b, dmg, a);
    if (dmg > 1.5) { a.hits++; sparks(G, a.x + nx * R, a.y + ny * R, 5, nx, ny); shake(G, 2 + dmg / 3); }
  }
  /* wedges (and the thick skirt, a little) get under the other robot, which then loses traction */
  function under(G, a, b, nx, ny) {
    var wa = a.wp.id === 'wedge' ? 1 : a.ar.skirt ? 0.55 : 0;
    if (!wa || a.dead || M.cos(a.a) * nx + M.sin(a.a) * ny < 0.7) return;
    var wb = b.wp.id === 'wedge' ? 1 : b.ar.skirt ? 0.55 : 0;
    if (wb >= wa && -(M.cos(b.a) * nx + M.sin(b.a) * ny) > 0.7) return;
    if (wa === 1 && b.under <= 0 && G.t - (a.uSaid || -9) > 5) { a.uSaid = G.t; say(G, who(a, 'You get', ' gets') + ' underneath!'); }
    b.under = 0.25;
  }
  /* shoving someone into a wall grinds them down */
  function pin(G, a, b, nx, ny, dt) {
    var lo = WALL + R + 3, hi = W - WALL - R - 3;
    if (a.dead || a.thr < 0.5 || M.cos(a.a) * nx + M.sin(a.a) * ny < 0.7 || (b.x > lo && b.x < hi && b.y > lo && b.y < hi)) return;
    hurt(G, b, dt * 4 * a.st.push * armMul(b), a);
    if (G.t - (a.pSaid || -9) > 6) { a.pSaid = G.t; say(G, who(b, 'You\u2019re', ' is') + ' pinned against the wall!'); }
  }
  function weapons(G, a, b) {
    if (!spinner(a) || a.dead || a.out || a.fall || b.out || b.fall || a.hitCd > 0 || M.abs(a.z - b.z) > 22) return;
    var dx = b.x - a.x, dy = b.y - a.y, dist = M.hypot(dx, dy) || 0.01, nx = dx / dist, ny = dy / dist, bar = a.wp.id === 'bar';
    var fa = M.cos(a.a) * nx + M.sin(a.a) * ny, fb = -(M.cos(b.a) * nx + M.sin(b.a) * ny);
    if (dist > 2 * R + (bar ? 10 : 5) || a.spin < (bar ? 0.3 : 0.25) || (!bar && fa < 0.62)) return;
    var e = (bar ? a.spin * a.spin * (fa > 0.3 ? 1 : 0.75) : M.pow(a.spin, 1.5)) * a.wp.punch * power(a);
    var dmg = (bar ? 21 : 5.5) * e, kb = (bar ? 360 : 190) * e, rec = (bar ? 140 : 50) * e, msg = '';
    if (b.wp.id === 'wedge' && fb > 0.6) {
      dmg *= bar ? 0.45 : 0.4; kb *= 0.55; rec *= 2.6; msg = 'Deflected! The wedge turns the ' + (bar ? 'spinner' : 'drum') + ' away.';
      if (!bar && a.z <= 0) { a.vz = 70 + 90 * e; a.z = 0.5; }
    } else if (spinner(b) && b.spin > 0.3 && fb > 0.5) { dmg *= 0.55; rec *= 2; b.spin *= 0.5; msg = 'Weapon clash!'; }
    a.hits++;
    hurt(G, b, dmg * armMul(b), a);
    var k = 130 / b.m, kx = bar ? nx : (nx + M.cos(a.a)) / 2, ky = bar ? ny : (ny + M.sin(a.a)) / 2;
    b.vx += kx * kb * k; b.vy += ky * kb * k; b.slide = 0.45; b.w += (M.random() - 0.5) * 18 * e;
    if (!bar && b.z <= 0 && fb < 0.6) { b.vz = 60 + 110 * e; b.z = 0.5; } /* drums pop them up */
    k = 130 / a.m; a.vx -= nx * rec * k; a.vy -= ny * rec * k;
    a.spin *= bar ? 0.3 : 0.7; a.hitCd = bar ? 0.35 : 0.3;
    sparks(G, a.x + nx * R * 1.1, a.y + ny * R * 1.1, 8 + 26 * e, nx, ny, e > 0.6);
    shake(G, 3 + 10 * e);
    if (msg) say(G, msg);
  }
  function ai(G, me, foe, dt, P) {
    var A = me.ai;
    if (me.dead) return;
    if (spinner(me) && !me.on && G.t > 0.2) me.on = true;
    var dx = foe.x - me.x, dy = foe.y - me.y, dist = M.hypot(dx, dy) || 1, ca = M.cos(me.a), sa = M.sin(me.a), fa = (ca * dx + sa * dy) / dist;
    A.fireT -= dt;
    if (me.wp.id === 'lifter' && me.cd <= 0 && A.fireT <= 0 && fa > 0.75 && dist < 2 * R + 12 && !foe.z) {
      if (M.random() < P.fire) flip(G, me, foe); else A.fireT = 0.35;
    }
    if (A.rev > 0) { A.rev -= dt; me.thr = -0.85; me.turn = A.rt; return; }
    A.stuck = M.abs(me.thr) > 0.5 && M.hypot(me.vx, me.vy) < 30 ? A.stuck + dt : 0;
    if (A.stuck > (dist < 2 * R + 6 ? 1.6 : 0.7)) { A.stuck = 0; A.rev = 0.45; A.rt = -A.rt; return; }
    A.t -= dt;
    if (A.t > 0) return; /* reaction time: keep the last command */
    A.t = P.react * (0.7 + M.random() * 0.6);
    var tx = foe.x, ty = foe.y, hold = 0, avoid = 0;
    if (P.hunt && G.pitOpen && !foe.dead) { /* line up behind the opponent to shove it into the pit */
      var px = foe.x - PX, py = foe.y - PY, pd = M.hypot(px, py) || 1, bx = foe.x + px / pd * 60, by = foe.y + py / pd * 60;
      if (pd < 260 && M.hypot(bx - me.x, by - me.y) > 45 && !inPit(bx, by, R)) { tx = bx; ty = by; }
    }
    if (spinner(me) && me.spin < 0.55 && dist > 90) { /* circle while the weapon spins up */
      hold = 1; tx = me.x - dy / dist * 80 * A.rt + dx / dist * 20; ty = me.y + dx / dist * 80 * A.rt + dy / dist * 20;
    }
    if (A.wand > 0) { A.wand -= P.react; tx = me.x + M.cos(A.wa) * 100; ty = me.y + M.sin(A.wa) * 100; }
    else if (M.random() < P.wander) { A.wand = 0.6; A.wa = M.random() * TAU; }
    var des = M.atan2(ty - me.y, tx - me.x) + (M.random() - 0.5) * P.jit;
    if (G.t > G.pitAt - 1 && M.random() < P.pit) {
      var dir = me.thr < 0 ? -1 : 1, lx = me.vx * 0.35 + ca * 45 * dir, ly = me.vy * 0.35 + sa * 45 * dir;
      if (inPit(me.x + lx, me.y + ly, R + 10) || inPit(me.x, me.y, R + 18)) { des = M.atan2(me.y - PY, me.x - PX); hold = 0; avoid = 1; }
    }
    var df = angDiff(des, me.a);
    me.turn = clamp(df * 2.4, -1, 1);
    me.thr = avoid && M.abs(df) > 1.6 ? -0.7 : P.thr * (M.abs(df) < 1.2 ? 1 : 0.2) * (hold ? 0.5 : 1);
  }
  function control(G, me, foe, dt) {
    if (me.fall || me.out) return;
    if (!me.me || G.auto) return ai(G, me, foe, dt, me.me ? DIFF.pilot : G.diff);
    var I = G.input;
    if (I.sm > 0.15) { /* touch joystick: point where you want to go */
      var des = M.atan2(I.sy, I.sx), df = angDiff(des, me.a), rev = M.abs(df) > 2.3;
      if (rev) df = angDiff(des + PI, me.a);
      me.turn = clamp(df * 2.6, -1, 1);
      me.thr = I.sm * M.max(0, M.cos(df)) * (rev ? -1 : 1);
    } else {
      me.thr = (I.up ? 1 : 0) - (I.down ? 1 : 0);
      me.turn = (I.right ? 1 : 0) - (I.left ? 1 : 0);
    }
    if (I.fire) { I.fire = false; trigger(G, me, foe); }
    if (me.dead) me.thr = me.turn = 0;
  }
  function fx(G, dt) {
    var i, q;
    G.shake *= M.exp(-dt * 9);
    for (i = G.fx.length - 1; i >= 0; i--) {
      q = G.fx[i]; q.l += dt;
      if (q.l > q.m) { G.fx.splice(i, 1); continue; }
      var drag = M.exp(-dt * (q.k === 0 ? 3 : q.k === 1 ? 2.5 : 1));
      q.vx *= drag; q.vy *= drag; q.x += q.vx * dt; q.y += q.vy * dt;
      if (q.k === 1) q.r += dt * 8;
    }
    for (i = G.txt.length - 1; i >= 0; i--) { q = G.txt[i]; q.l += dt; q.y -= 28 * dt; if (q.l > 0.9) G.txt.splice(i, 1); }
  }
  function judge(G) {
    var p = G.bots[0], o = G.bots[1], r = '', how = '';
    if (p.out || o.out) { how = 'pit'; r = p.out && o.out ? 'draw' : o.out ? 'win' : 'lose'; }
    else if (p.dead || o.dead) { how = 'ko'; r = p.dead && o.dead ? 'draw' : o.dead ? 'win' : 'lose'; }
    else if (G.t >= G.T) { /* judges' decision on damage dealt, then armour left */
      how = 'judges';
      var df = p.dealt - o.dealt;
      r = M.abs(df) < 1 ? (M.abs(p.hp - o.hp) < 1 ? 'draw' : p.hp > o.hp ? 'win' : 'lose') : df > 0 ? 'win' : 'lose';
    }
    if (!r) return;
    G.over = { r: r, how: how, t: M.min(G.t, G.T) };
    say(G, (how === 'judges' ? 'Time! The judges score it on damage: ' + M.round(p.dealt) + ' to ' + M.round(o.dealt) + '.' :
      how === 'pit' ? (r === 'win' ? o.name + ' is in the pit.' : r === 'lose' ? 'You\u2019re in the pit.' : 'Both robots are in the pit.') :
      r === 'win' ? 'Knockout! ' + o.name + ' is done.' : r === 'lose' ? 'Knockout. ' + o.name + ' has beaten you.' : 'Double knockout.') +
      { win: ' You win!', lose: ' You lose.', draw: ' It\u2019s a draw.' }[r], 1);
  }
  function step(G, dt) {
    var p = G.bots[0], o = G.bots[1];
    if (G.cd > 0) {
      G.cd -= dt;
      if (G.cd <= 0) say(G, 'Fight! ' + (p.wp.id === 'lifter' ? 'Space fires your flipper.' : spinner(p) ? 'Press Space to spin up your weapon.' : 'Get your wedge under them.'), 1);
      return;
    }
    if (!G.over) G.t += dt;
    if (!G.pitWarn && G.t > G.pitAt - 3) { G.pitWarn = true; say(G, 'The pit opens in 3 seconds.', 1); }
    if (!G.pitOpen && G.t >= G.pitAt) { G.pitOpen = true; say(G, 'The pit is open! Keep clear of it.', 1); shake(G, 3); }
    if (G.pitOpen) G.pitAnim = M.min(1, G.pitAnim + dt / 0.8);
    if (G.over) p.thr = p.turn = o.thr = o.turn = 0;
    else { control(G, p, o, dt); control(G, o, p, dt); }
    move(G, p, dt); move(G, o, dt);
    collide(G, p, o, dt);
    weapons(G, p, o); weapons(G, o, p);
    fx(G, dt);
    if (!G.over) judge(G);
  }

  /* ------------------------------------------------------------------ drawing (arena units; the caller sets the scale) */
  function rr(c, x, y, w, h, r) {
    c.beginPath(); c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
  }
  function mono(px, wt) { return (wt || 600) + ' ' + px + 'px "IBM Plex Mono", ui-monospace, Menlo, monospace'; }
  function display(px) { return '700 ' + px + 'px "Chakra Petch", sans-serif'; }
  function drawBg(c) {
    var i, j, g, p, s = 11, IN = W - 2 * WALL, cell = IN / 5;
    function rn() { s = s * 16807 % 2147483647; return s / 2147483647; }
    function lines(step, from) { c.beginPath(); for (i = from; i < IN; i += step) { p = WALL + i; c.moveTo(p, WALL); c.lineTo(p, W - WALL); c.moveTo(WALL, p); c.lineTo(W - WALL, p); } c.stroke(); }
    c.fillStyle = '#121518'; c.fillRect(0, 0, W, W);
    g = c.createLinearGradient(0, 0, W, W); g.addColorStop(0, '#2f363c'); g.addColorStop(1, '#24292e');
    c.fillStyle = g; c.fillRect(WALL, WALL, IN, IN);
    c.fillStyle = 'rgba(255,255,255,0.022)';
    for (i = 0; i < 5; i++) for (j = 0; j < 5; j++) if ((i + j) % 2) c.fillRect(WALL + i * cell, WALL + j * cell, cell, cell);
    c.lineWidth = 1; c.strokeStyle = 'rgba(232,222,196,0.055)'; lines(cell / 4, cell / 4);
    c.lineWidth = 2; c.strokeStyle = 'rgba(0,0,0,0.4)'; lines(cell, cell);
    c.fillStyle = 'rgba(0,0,0,0.35)';
    for (i = 0; i < 5; i++) for (j = 0; j < 5; j++) [8, cell - 8].forEach(function (a) { [8, cell - 8].forEach(function (b) { c.beginPath(); c.arc(WALL + i * cell + a, WALL + j * cell + b, 1.8, 0, TAU); c.fill(); }); });
    c.lineCap = 'round';
    for (i = 0; i < 34; i++) { /* scuffs */
      c.strokeStyle = rn() < 0.6 ? 'rgba(0,0,0,0.22)' : 'rgba(255,240,210,0.05)'; c.lineWidth = 0.8 + rn() * 2.4;
      var x = 50 + rn() * 500, y = 50 + rn() * 500, r = 16 + rn() * 80, a0 = rn() * TAU;
      c.beginPath(); c.arc(x, y, r, a0, a0 + 0.25 + rn() * 0.9); c.stroke();
    }
    c.strokeStyle = 'rgba(255,176,0,0.28)'; c.lineWidth = 2; c.setLineDash([6, 8]);
    c.beginPath(); c.arc(300, 420, 46, 0, TAU); c.stroke(); c.setLineDash([]);
    c.font = mono(11); c.textAlign = 'center';
    [[120, 'P1'], [480, 'P2']].forEach(function (q) { /* start boxes */
      var h = 36; c.strokeStyle = 'rgba(255,176,0,0.45)'; c.beginPath();
      [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (k) { c.moveTo(q[0] + k[0] * h, 420 + k[1] * (h - 9)); c.lineTo(q[0] + k[0] * h, 420 + k[1] * h); c.lineTo(q[0] + k[0] * (h - 9), 420 + k[1] * h); });
      c.stroke(); c.fillStyle = 'rgba(255,176,0,0.4)'; c.fillText(q[1], q[0], 420 + h + 14);
    });
    c.fillStyle = 'rgba(232,222,196,0.07)'; c.font = display(26); c.fillText('RISING SUN ARENA', 300, 540);
    c.font = mono(11); c.fillText('ANTWEIGHT CLASS', 300, 558);
    c.save(); c.beginPath(); c.rect(0, 0, W, W); c.rect(WALL, WALL, IN, IN); c.clip('evenodd'); /* hazard-striped walls */
    c.fillStyle = '#1b1e21'; c.fillRect(0, 0, W, W);
    c.strokeStyle = '#ffb000'; c.lineWidth = 7; c.beginPath();
    for (i = -W; i < W; i += 20) { c.moveTo(i, 0); c.lineTo(i + W, W); }
    c.stroke(); c.restore();
    c.strokeStyle = 'rgba(0,0,0,0.65)'; c.lineWidth = 4; c.strokeRect(WALL + 2, WALL + 2, IN - 4, IN - 4);
    c.strokeStyle = 'rgba(255,196,90,0.5)'; c.lineWidth = 1; c.strokeRect(WALL + 0.5, WALL + 0.5, IN - 1, IN - 1);
    g = c.createRadialGradient(300, 300, 170, 300, 300, 440); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,0.5)');
    c.fillStyle = g; c.fillRect(WALL, WALL, IN, IN);
  }
  function drawPit(c, open, t) {
    var h = PS / 2, x = PX - h, y = PY - h, g, i, dw = h * (1 - open);
    c.fillStyle = '#040506'; c.fillRect(x, y, PS, PS);
    g = c.createRadialGradient(PX, PY, 6, PX, PY, PS * 0.8); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(58,66,74,0.95)');
    c.fillStyle = g; c.fillRect(x, y, PS, PS);
    if (dw > 0.5) { /* the doors slide apart when it opens */
      [x, PX + h - dw].forEach(function (dx) {
        c.fillStyle = '#3b434a'; c.fillRect(dx, y, dw, PS);
        c.strokeStyle = 'rgba(0,0,0,0.3)'; c.lineWidth = 1; c.beginPath();
        for (i = 6; i < PS; i += 9) { c.moveTo(dx + 2, y + i); c.lineTo(dx + dw - 2, y + i); }
        c.stroke();
      });
      c.fillStyle = '#1b1e21'; c.fillRect(PX - 1.5, y, 3, PS);
      if (open < 0.05) { c.fillStyle = 'rgba(255,176,0,0.55)'; c.font = display(22); c.textAlign = 'center'; c.fillText('PIT', PX, PY + 8); }
    }
    c.lineWidth = 6; c.strokeStyle = '#1b1e21'; c.strokeRect(x - 3, y - 3, PS + 6, PS + 6);
    c.setLineDash([9, 9]); c.strokeStyle = '#ffb000'; c.strokeRect(x - 3, y - 3, PS + 6, PS + 6); c.setLineDash([]);
    if (open >= 1) { c.strokeStyle = 'rgba(255,90,78,' + (calm() ? 0.6 : 0.45 + 0.3 * M.sin(t * 5)) + ')'; c.lineWidth = 2; c.strokeRect(x + 2, y + 2, PS - 4, PS - 4); }
  }
  function drawBot(c, b, sc) {
    var r = R, L = b.look, s = (1 + b.z / 70) * (sc || 1) * (b.fall ? 1 - b.fall * 0.75 : 1), wp = b.wp.id, g, k;
    c.save(); c.translate(b.x, b.y);
    if (b.fall) c.globalAlpha = 1 - b.fall * 0.6;
    c.save(); c.translate((3 + b.z * 0.45) * (sc || 1), (6 + b.z * 0.6) * (sc || 1)); c.rotate(b.a); c.scale(s, s); /* shadow, further away when airborne */
    c.fillStyle = 'rgba(0,0,0,' + M.max(0.12, 0.45 - b.z / 150) + ')'; rr(c, -r * 0.95, -r * 1.02, r * 2.1, r * 2.04, 9); c.fill();
    c.restore();
    c.rotate(b.a); c.scale(s, s);
    (b.dr.n === 4 ? [-0.52, 0.34] : [-0.14]).forEach(function (wx) { /* wheels */
      [-1.06, 0.72].forEach(function (wy) {
        c.fillStyle = '#0e1012'; rr(c, (wx - 0.3) * r, wy * r, 0.6 * r, 0.34 * r, 3); c.fill();
        c.fillStyle = 'rgba(255,255,255,0.1)'; for (k = 0; k < 4; k++) c.fillRect((wx - 0.26 + k * 0.15) * r, wy * r + 1, 1.2, 0.34 * r - 2);
      });
    });
    if (wp === 'wedge' || b.ar.skirt) {
      var tip = wp === 'wedge' ? 1.2 : 0.98;
      g = c.createLinearGradient(r * 0.5, 0, r * tip, 0); g.addColorStop(0, wp === 'wedge' ? '#59626a' : '#2a2f34'); g.addColorStop(1, wp === 'wedge' ? '#d7dbde' : '#6b747c');
      c.fillStyle = g; c.beginPath(); c.moveTo(r * 0.45, -r * 0.86); c.lineTo(r * tip, -r * 0.98); c.lineTo(r * tip, r * 0.98); c.lineTo(r * 0.45, r * 0.86); c.closePath(); c.fill();
      c.strokeStyle = 'rgba(255,255,255,0.55)'; c.lineWidth = 1.2; c.beginPath(); c.moveTo(r * tip - 0.6, -r * 0.96); c.lineTo(r * tip - 0.6, r * 0.96); c.stroke();
    }
    if (wp === 'lifter') {
      var ext = 1.1 + 0.28 * b.arm;
      c.fillStyle = b.arm > 0.05 ? '#e4e8ea' : '#8e979e'; rr(c, r * 0.5, -r * 0.8, r * (ext - 0.5), r * 1.6, 3); c.fill();
      c.fillStyle = 'rgba(0,0,0,0.35)'; c.fillRect(r * 0.5, -r * 0.8, 2.5, r * 1.6);
      c.strokeStyle = 'rgba(0,0,0,0.25)'; c.lineWidth = 1; c.beginPath();
      for (k = -0.5; k <= 0.5; k += 0.5) { c.moveTo(r * 0.62, k * r); c.lineTo(r * (ext - 0.08), k * r); }
      c.stroke();
    }
    if (wp === 'drum') {
      g = c.createLinearGradient(0, -r * 0.72, 0, r * 0.72); g.addColorStop(0, '#454d54'); g.addColorStop(0.5, '#9aa3aa'); g.addColorStop(1, '#3a4148');
      c.fillStyle = g; rr(c, r * 0.6, -r * 0.74, r * 0.56, r * 1.48, 6); c.fill();
      c.fillStyle = 'rgba(20,23,26,' + (0.85 - b.spin * 0.55) + ')';
      for (k = 0; k < 3; k++) c.fillRect(r * 0.62 + ((b.phase * 0.35 + k / 3) % 1) * r * 0.48, -r * 0.72, 3, r * 1.44);
    }
    rr(c, -r * 0.9, -r * 0.84, r * 1.5, r * 1.68, b.ar.id === 'petg' ? 3 : 9); /* shell */
    c.fillStyle = L.c; c.fill();
    c.lineWidth = b.ar.id === 'thick' ? 4 : 2; c.strokeStyle = 'rgba(0,0,0,0.5)'; c.stroke();
    g = c.createLinearGradient(-r, -r, r, r); g.addColorStop(0, 'rgba(255,255,255,' + (b.ar.id === 'petg' ? 0.3 : 0.14) + ')'); g.addColorStop(0.5, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(0,0,0,0.22)');
    c.fillStyle = g; c.fill();
    rr(c, -r * 0.66, -r * 0.5, r * 0.9, r, 4); c.fillStyle = 'rgba(0,0,0,0.2)'; c.fill();
    c.fillStyle = L.c2; c.beginPath(); c.moveTo(r * 0.5, 0); c.lineTo(r * 0.06, -r * 0.36); c.lineTo(r * 0.06, -r * 0.16); c.lineTo(r * 0.26, 0); c.lineTo(r * 0.06, r * 0.16); c.lineTo(r * 0.06, r * 0.36); c.closePath(); c.fill();
    if (b.hp < 65 || b.cracked) { /* battle damage */
      c.strokeStyle = 'rgba(0,0,0,0.5)'; c.lineWidth = 1.2; c.beginPath();
      c.moveTo(-r * 0.7, -r * 0.6); c.lineTo(-r * 0.4, -r * 0.35); c.lineTo(-r * 0.45, -r * 0.1);
      if (b.hp < 35 || b.cracked) { c.moveTo(r * 0.3, r * 0.75); c.lineTo(0, r * 0.45); c.lineTo(-r * 0.2, r * 0.6); c.lineTo(-r * 0.5, r * 0.4); }
      c.stroke();
    }
    c.fillStyle = b.dead ? '#3a3f44' : (b.on || wp === 'wedge' || (wp === 'lifter' && b.cd <= 0)) ? '#6dff9f' : '#ffb000'; /* status LED */
    c.beginPath(); c.arc(-r * 0.7, r * 0.58, 2.6, 0, TAU); c.fill();
    if (wp === 'bar') {
      c.save(); c.rotate(b.phase);
      if (b.spin > 0.3) {
        c.fillStyle = 'rgba(225,230,235,' + 0.12 * b.spin + ')'; c.beginPath(); c.arc(0, 0, r * 1.38, 0, TAU); c.fill();
        c.strokeStyle = 'rgba(255,176,0,' + 0.4 * b.spin + ')'; c.lineWidth = 1.5; c.stroke();
      }
      g = c.createLinearGradient(0, -r * 0.15, 0, r * 0.15); g.addColorStop(0, '#dfe3e6'); g.addColorStop(1, '#6f7880');
      c.globalAlpha *= 1 - 0.6 * b.spin; c.fillStyle = g; rr(c, -r * 1.38, -r * 0.15, r * 2.76, r * 0.3, 3); c.fill();
      c.globalAlpha = b.fall ? 1 - b.fall * 0.6 : 1;
      c.fillStyle = '#1b1e21'; c.beginPath(); c.arc(0, 0, r * 0.22, 0, TAU); c.fill();
      c.fillStyle = '#ffb000'; c.beginPath(); c.arc(0, 0, r * 0.08, 0, TAU); c.fill();
      c.restore();
    }
    if (b.flash > 0) { c.fillStyle = 'rgba(255,255,255,' + M.min(0.45, b.flash * 3) + ')'; rr(c, -r * 0.9, -r * 0.84, r * 1.5, r * 1.68, 9); c.fill(); }
    c.restore();
  }
  function drawTag(c, b, txt, col, fs, sc, up) {
    if (b.out || b.fall) return;
    var s = (1 + b.z / 70) * (sc || 1), hi = b.y - R * 1.3 * s - 4 - b.z * 0.2, lo = b.y + R * 1.3 * s + fs + 4;
    var y = (up && hi > fs + 4) || lo > W - 6 ? hi : lo; /* keep the tag inside the arena */
    c.font = mono(fs); c.textAlign = 'center';
    var w = c.measureText(txt).width + fs * 0.9;
    c.fillStyle = 'rgba(12,14,16,0.78)'; c.fillRect(b.x - w / 2, y - fs * 1.05, w, fs * 1.45);
    c.fillStyle = col; c.fillText(txt, b.x, y);
  }
  function drawScene(c, G, fs, t) {
    drawPit(c, G.pitAnim, t);
    G.bots.slice().sort(function (a, b) { return a.z - b.z; }).forEach(function (b) { if (!b.out) drawBot(c, b, G.sc); });
    c.save(); c.globalCompositeOperation = 'lighter';
    G.fx.forEach(function (q) {
      var k = 1 - q.l / q.m, rad, gr;
      if (q.k === 0) { c.globalAlpha = k; c.strokeStyle = q.c; c.lineWidth = 2.4; c.beginPath(); c.moveTo(q.x, q.y); c.lineTo(q.x - q.vx * 0.045, q.y - q.vy * 0.045); c.stroke(); }
      else if (q.k === 3) { /* impact flash */
        rad = q.s * (1 + q.l * 6); gr = c.createRadialGradient(q.x, q.y, 0, q.x, q.y, rad);
        gr.addColorStop(0, 'rgba(255,244,194,' + k + ')'); gr.addColorStop(0.4, 'rgba(255,176,0,' + 0.6 * k + ')'); gr.addColorStop(1, 'rgba(255,120,0,0)');
        c.globalAlpha = 1; c.fillStyle = gr; c.beginPath(); c.arc(q.x, q.y, rad, 0, TAU); c.fill();
      }
    });
    c.restore();
    G.fx.forEach(function (q) {
      var k = 1 - q.l / q.m;
      if (q.k === 1) { c.save(); c.globalAlpha = k; c.translate(q.x, q.y); c.rotate(q.r); c.fillStyle = q.c; c.fillRect(-2.5, -2, 5, 4); c.restore(); }
      else if (q.k === 2) { c.fillStyle = 'rgba(128,134,140,' + 0.32 * k + ')'; c.beginPath(); c.arc(q.x, q.y, 5 + (1 - k) * 16, 0, TAU); c.fill(); }
    });
    G.bots.forEach(function (b, i) { /* the upper robot is labelled above, the lower one below, so tags never collide */
      var o = G.bots[1 - i], up = G.sc || !o || o.out || b.y < o.y || (b.y === o.y && b.me);
      drawTag(c, b, b.me ? 'YOU' : b.name.toUpperCase(), b.me ? '#ffb000' : '#f4f0e6', fs, G.sc, up);
    });
    c.font = mono(fs * 1.15, 700); c.textAlign = 'center';
    G.txt.forEach(function (q) { c.globalAlpha = 1 - q.l / 0.9; c.fillStyle = q.c; c.fillText(q.s, q.x, q.y); });
    c.globalAlpha = 1;
  }

  /* ------------------------------------------------------------------ "Build it for real": match the build to store products */
  var cache = {};
  function load(root, handle) {
    var url = root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250';
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) { return j.products || []; });
      cache[url].catch(function () { delete cache[url]; });
    }
    return cache[url];
  }
  function avail(p) { return (p.variants || []).some(function (v) { return v.available; }); }
  function num(t, re) { var m = t.match(re); return m ? +m[1] : 0; }
  function shopPlan(b) {
    var dr = part('drive', b.drive), wp = part('weapon', b.weapon), ar = part('armour', b.armour), bt = part('battery', b.battery), plan = [];
    function has(re, p) { return re.test(p.title) ? 1 : 0; }
    plan.push({ t: 'Control', sub: 'Receiver + dual ESC board', specs: [{ n: 2, uniq: 1, inc: /malenki|llama|aspire|receiver|control board/i, exc: /switch|starter kit|transmitter/i,
      score: function (p) { return has(/malenki|llama|control board/i, p) * 3 || has(/controller/i, p) * 2; } }] });
    plan.push({ t: 'Drive', sub: dr.n + '\u00d7 N20 gear motors, about ' + dr.rpm + ' rpm', specs: [{ n: 2, inc: /\bn20\b|gear ?motor/i, exc: /tyre|tire|rubber/i,
      score: function (p) { var v = num(p.title, /(\d{3,4})\s*rpm/i); return (v ? -M.abs(v - dr.rpm) / 100 : -6) + has(/bracket and wheel/i, p) / 2; } }] });
    if (wp.id === 'wedge') plan.push({ t: 'Weapon', sub: 'Wedge', note: 'No weapon motor needed. The wedge is part of your printed shell, so spend the grams on armour or drive.' });
    else if (wp.id === 'lifter') plan.push({ t: 'Weapon', sub: 'Servo for the flipper', specs: [{ n: 2, inc: /servo/i, exc: /360|continuous|tire|wheel/i,
      score: function (p) { return has(/\bmg\b|metal/i, p) + has(/\bhv\b|2s|7\.4v/i, p); } }] });
    else plan.push({ t: 'Weapon', sub: 'Brushless motor + ESC for the ' + (wp.id === 'bar' ? 'bar' : 'drum'), specs: [
      { n: 1, inc: /brushless motor|bldc/i, exc: /saw|disc|chuck|esc/i, score: function (p) { return has(/18mm|1503/i, p) * 2 || has(/combat/i, p); } },
      { n: 1, inc: /(brushless|am32).*\besc\b|\besc\b.*(brushless|am32)|littlebee/i, exc: /programming|brushed/i,
        score: function (p) { var m = p.title.match(/(\d)s?\s*-\s*(\d)s/i); return (m ? (bt.cells >= +m[1] && bt.cells <= +m[2] ? 3 : -3) : 0) + has(/am32/i, p); } }] });
    plan.push({ t: 'Battery', sub: bt.cells + 'S ' + bt.mah + ' mAh LiPo', specs: [{ n: 2, inc: /lipo|tattu|\b[23]s\b/i, exc: /charger|\besc\b|servo|motor/i,
      score: function (p) { var c = num(p.title, /\b([123])s\b/i) || (/7\.[46]v/i.test(p.title) ? 2 : 0), m = num(p.title, /(\d{3,4})\s*mah/i); return (c === bt.cells ? 5 : -5) - (m ? M.abs(m - bt.mah) / 100 : 3); } }] });
    plan.push({ t: 'Radio', sub: 'Transmitter', specs: [{ n: 1, inc: /flysky|fs-i6x|transmitter/i, exc: /compatible receiver|control board/i, score: function (p) { return has(/fs-?i6x/i, p) * 2; } }] });
    plan.push({ t: 'Armour', sub: ar.id === 'petg' ? 'You chose PETG, but most ant shells are printed in TPU' : 'TPU filament for your printed shell', arm: 1,
      specs: [{ n: 2, inc: /./, score: function (p) { return /nova|rising sun/i.test(p.title + ' ' + p.vendor) ? 1 : 0; } }] });
    return plan;
  }
  /* best matches for one spec: available first, then best score, then collection order; never repeats a product */
  function pick(list, spec, used) {
    var seen = {};
    return list.map(function (p, i) { return { p: p, i: i, a: avail(p), s: spec.score ? spec.score(p) : 0 }; })
      .filter(function (x) { var t = x.p.title || ''; return !used[x.p.id] && spec.inc.test(t) && !(spec.exc && spec.exc.test(t)) && !/events|bookings|lessons/i.test(x.p.product_type || ''); })
      .sort(function (a, b) { return (b.a - a.a) || (b.s - a.s) || (a.i - b.i); })
      .filter(function (x) { var k = (x.p.title || '').toLowerCase().split(/\s+/).slice(0, 2).join(' '); if (spec.uniq && seen[k]) return false; seen[k] = 1; return true; })
      .slice(0, spec.n).map(function (x) { used[x.p.id] = 1; return x.p; });
  }
  var AUD = window.Intl ? new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }) : null;
  function card(p, root) {
    var img = p.images && p.images[0] ? p.images[0].src : '', prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(isFinite);
    var min = prices.length ? M.min.apply(null, prices) : null, from = prices.length > 1 && M.max.apply(null, prices) > min;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    return '<a class="rs-mini rs-arena__card" href="' + esc(root + 'products/' + p.handle) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="120" height="120">' : '<span class="rs-arena__noimg" aria-hidden="true"></span>') +
      '<span class="rs-mini__t">' + esc(p.title) + '</span><span class="rs-mini__p">' +
      (min != null ? (from ? 'From ' : '') + (AUD ? AUD.format(min) : '$' + min.toFixed(2)) : '') + (avail(p) ? '' : ' <em>sold out</em>') + '</span></a>';
  }

  /* ------------------------------------------------------------------ one section instance */
  var instances = [];
  function Arena(sec) {
    var cfg = { limit: 150, seconds: 60, parts: 'robot-combat', armour: 'tpu-3d-filament', root: '/' };
    try { var c = JSON.parse($('[data-rs-arena-config]', sec).textContent); for (var k in c) if (c[k] != null && c[k] !== '') cfg[k] = c[k]; } catch (e) { /* keep defaults */ }
    cfg.limit = +cfg.limit || 150; cfg.seconds = M.max(10, +cfg.seconds || 60);
    if (!/\/$/.test(cfg.root)) cfg.root += '/';
    function q(s) { return $(s, sec); }
    function qa(s) { return $$(s, sec); }
    function txt(s, v) { var e = q(s); if (e) e.textContent = v; }
    var form = q('[data-rs-build]'), stage = q('[data-rs-stage]'), cv = q('[data-rs-canvas]');
    if (!form || !stage || !cv) return null;
    var ov = q('[data-rs-overlay]'), big = q('[data-rs-big]'), pz = q('[data-rs-pause]'), meter = q('[data-rs-meter]'), msg = q('[data-rs-msg]'), btn = q('[data-rs-launch]');
    var hp = qa('[data-rs-hp]'), hpv = qa('[data-rs-hpv]'), au2 = q('[data-rs-auto2]'), hint = q('[data-rs-hint]');
    var ctx = cv.getContext('2d'), bg = d.createElement('canvas'), bgx = bg.getContext('2d');
    var build = {}, sel = {}, G = null, mode = 'build', paused = '', raf = 0, last = 0, acc = 0, speed = 1, lastSay = 0, hudT = 0, endT = 0;
    var ovText = null, launchedAt = 0, vis = true, size = 0, css = 0, tried = false;
    var input = { up: 0, down: 0, left: 0, right: 0, fire: false, sx: 0, sy: 0, sm: 0 };
    var touch = !!(window.matchMedia && matchMedia('(pointer: coarse)').matches);
    function name(slot, id) { var i = q('input[name="' + slot + '"][value="' + id + '"]'), b = i && i.parentNode.querySelector('b'); return b ? b.textContent : id; }
    function readForm() {
      SLOTS.forEach(function (s) { var i = q('input[name="' + s + '"]:checked'); build[s] = i ? i.value : PARTS[s][0].id; });
      ['opp', 'diff'].forEach(function (s) { var i = q('input[name="' + s + '"]:checked'); sel[s] = i ? i.value : ''; });
      var a = q('input[name="auto"]'); sel.auto = !!(a && a.checked);
    }
    /* the badges come from PARTS, so the copy in the section can't drift from the maths */
    qa('[data-rs-w]').forEach(function (em) { var i = em.parentNode.parentNode.parentNode.querySelector('input'), w = part(i.name, i.value).w; em.textContent = (w ? '+' : '') + w + ' g'; });
    txt('[data-rs-control]', CONTROL_G);

    /* ---------- build bay */
    function update() {
      var g = weightOf(build), over = g - cfg.limit, st = statsOf(build), f, k;
      txt('[data-rs-grams]', g);
      q('[data-rs-fill]').style.width = M.min(100, g / cfg.limit * 100) + '%';
      meter.classList.toggle('is-over', over > 0);
      if (over > 0) {
        f = fixes(build, cfg.limit);
        msg.textContent = (tried ? 'Can\u2019t launch yet: over' : 'Over') + ' the limit by ' + over + ' g. ' +
          (f.length ? 'Try ' + f.map(function (x) { return 'the ' + name(x.slot, x.p.id) + ' (\u2212' + x.save + ' g)'; }).join(' or ') + '.' : 'Swap a heavy part for a lighter one.');
      } else msg.textContent = (over ? -over + ' g spare.' : 'Right on the limit.') + ' Ready to launch.';
      btn.setAttribute('aria-disabled', over > 0);
      for (k in st) { var v = M.round(st[k] * 100); q('[data-rs-stat="' + k + '"]').style.width = v + '%'; txt('[data-rs-statv="' + k + '"]', v); }
      qa('input[type="radio"]').forEach(function (i) { /* flag parts that would put you over */
        if (!PARTS[i.name]) return;
        var b2 = {}; for (k in build) b2[k] = build[k]; b2[i.name] = i.value;
        i.parentNode.classList.toggle('is-heavy', weightOf(b2) > cfg.limit);
      });
      qa('[data-rs-intel-for]').forEach(function (x) {
        var id = x.getAttribute('data-rs-intel-for'), sp = x.querySelector('.rs-arena__intel-spec'), o = oppBy(id);
        x.hidden = id !== sel.opp;
        if (sp) sp.textContent = weightOf(o.b) + ' g // ' + SLOTS.map(function (s) { return name(s, o.b[s]); }).join(' // ');
      });
      if (mode === 'build') hudIdle();
      draw();
    }
    form.addEventListener('change', function () { readForm(); update(); });
    form.addEventListener('keydown', function (e) { if (e.key === 'Enter' && /radio|checkbox/.test(e.target.type)) { e.preventDefault(); launch(); } });
    form.addEventListener('submit', function (e) { e.preventDefault(); launch(); });

    /* ---------- modes */
    function setMode(m) {
      mode = m;
      form.hidden = m !== 'build';
      [['[data-rs-live]', 'fight'], ['[data-rs-debrief]', 'debrief'], ['[data-rs-controls]', 'fight'], ['[data-rs-intel]', 'build']].forEach(function (x) { var e = q(x[0]); if (e) e.hidden = m !== x[1]; });
      if (m === 'build') { var s = q('[data-rs-shop]'); if (s) s.hidden = true; }
      sec.setAttribute('data-rs-mode', m);
      qa('[data-rs-step]').forEach(function (li) {
        var on = li.getAttribute('data-rs-step') === m;
        li.classList.toggle('is-on', on);
        if (on) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      });
    }
    function launch() {
      if (weightOf(build) > cfg.limit) {
        meter.classList.remove('is-shake'); void meter.offsetWidth; meter.classList.add('is-shake');
        tried = true; update(); tried = false;
        return;
      }
      start(sel.opp === 'random' || !sel.opp ? pickOpp() : sel.opp);
    }
    function pickOpp(not) { var l = OPPS.filter(function (o) { return o.id !== not; }); return l[M.random() * l.length | 0].id; }
    function start(oid) {
      var opp = oppBy(oid), b = {}, k, intel = q('[data-rs-intel-for="' + oid + '"] p'), sc = q('[data-rs-scout]');
      for (k in build) b[k] = build[k];
      G = newGame({ build: b, opp: opp, diff: sel.diff, T: cfg.seconds, auto: sel.auto });
      G.input = input; clearKeys(); input.fire = false; input.sm = 0;
      endT = 0; paused = ''; launchedAt = performance.now();
      setMode('fight'); overlay('');
      txt('[data-rs-foe]', opp.name); txt('[data-rs-vs]', opp.name);
      SLOTS.forEach(function (s) { txt('[data-rs-spec="' + s + '"]', name(s, b[s])); });
      txt('[data-rs-spec="weight"]', weightOf(b) + ' g');
      k = b.weapon === 'lifter' || b.weapon === 'wedge' ? b.weapon : 'spin';
      qa('[data-rs-wkey]').forEach(function (x) { x.hidden = x.getAttribute('data-rs-wkey') !== k; });
      if (sc) sc.innerHTML = '<b>' + esc(opp.name) + ':</b> ' + esc(intel ? intel.textContent : opp.tag);
      if (au2) au2.checked = sel.auto;
      cv.setAttribute('aria-label', 'Top-down robot arena. Your robot, in amber, starts on the left. ' + opp.name + ', a ' + opp.tag + ', starts on the right. The pit in the upper middle opens ' + M.round(G.pitAt) + ' seconds in.');
      comm('Get ready. You versus ' + opp.name + (sel.diff === 'veteran' ? ', Veteran' : '') + '.', 1);
      stage.focus({ preventScroll: true });
      var r = (q('.rs-arena__side') || stage).getBoundingClientRect();
      if (r.top < 0 || r.bottom > innerHeight) (q('.rs-arena__hud') || stage).scrollIntoView({ block: 'start', behavior: calm() ? 'auto' : 'smooth' });
      hud(); go();
    }

    /* ---------- HUD, commentary, overlay */
    function hudIdle() {
      hp.forEach(function (h) { h.style.width = '100%'; h.parentNode.parentNode.classList.remove('is-low'); });
      hpv.forEach(function (h) { h.textContent = '100%'; });
      txt('[data-rs-clock]', mmss(cfg.seconds));
      txt('[data-rs-foe]', sel.opp && sel.opp !== 'random' ? oppBy(sel.opp).name : 'Mystery');
    }
    function hud() {
      if (!G) return;
      var p = G.bots[0], bat = q('[data-rs-bat]'), pit = q('[data-rs-pit]');
      G.bots.forEach(function (b, i) {
        var v = M.max(0, M.round(b.hp));
        if (hp[i]) { hp[i].style.width = v + '%'; hp[i].parentNode.parentNode.classList.toggle('is-low', v < 30); }
        if (hpv[i]) hpv[i].textContent = v + '%';
      });
      txt('[data-rs-clock]', mmss(G.cd > 0 ? G.T : G.T - G.t));
      txt('[data-rs-wpn]', p.dead ? 'Offline' : p.wp.id === 'lifter' ? (p.cd > 0 ? 'Resetting' : 'Ready') : spinner(p) ? (p.on ? 'Spin ' + M.round(p.spin * 100) + '%' : 'Off, ' + (touch ? 'tap Weapon' : 'press Space')) : 'Wedge (passive)');
      if (bat) { bat.textContent = M.round(p.e * 100) + '%'; bat.parentNode.classList.toggle('is-warn', p.e < 0.25); }
      if (pit) { pit.textContent = G.pitOpen ? 'Open' : 'Opens in ' + M.ceil(G.pitAt - G.t) + 's'; pit.parentNode.classList.toggle('is-warn', G.pitOpen); }
      if (hint) hint.hidden = !(mode === 'fight' && !paused && !G.auto && !touch && !G.over && !stage.contains(d.activeElement));
    }
    function comm(s, prio) {
      var now = performance.now();
      if (!prio && now - lastSay < 1300) return; /* keep the live region calm */
      lastSay = now; txt('[data-rs-comm]', s);
    }
    function overlay(t, cls) {
      if (t === ovText) return;
      ovText = t; ov.hidden = !t; pz.hidden = true; big.hidden = false;
      ov.className = 'rs-arena__overlay' + (cls ? ' ' + cls : '');
      big.textContent = t; big.style.animation = 'none'; void big.offsetWidth; big.style.animation = '';
    }

    /* ---------- canvas */
    function resize() {
      var w = stage.clientWidth;
      if (!w) return;
      var px = M.round(w * M.min(2, window.devicePixelRatio || 1)); /* cap the device-pixel ratio at 2 */
      css = w;
      if (px !== size) { size = px; cv.width = cv.height = bg.width = bg.height = px; bgx.setTransform(px / W, 0, 0, px / W, 0, 0); drawBg(bgx); }
      draw();
    }
    function draw() {
      if (!size) return;
      var k = size / W, fs = 12 * W / css, t = performance.now() / 1000;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(bg, 0, 0);
      if (G && mode !== 'build') {
        var sx = G.shake > 0.3 ? (M.random() - 0.5) * G.shake : 0, sy = G.shake > 0.3 ? (M.random() - 0.5) * G.shake : 0;
        ctx.setTransform(k, 0, 0, k, sx * k, sy * k); drawScene(ctx, G, fs, t);
        return;
      }
      /* build bay preview: your robot against the selected opponent */
      var o = sel.opp && sel.opp !== 'random' ? oppBy(sel.opp) : null, sc = W / css > 1.4 ? 1.7 : 2, y = 395, ly = y + R * sc + fs * 2.1;
      var P = { bots: [makeBot(build, 185, y, -0.35, YOU, 'You')], fx: [], txt: [], pitAnim: 0, sc: sc };
      P.bots[0].me = true; P.bots[0].spin = 0.15; P.bots[0].phase = 0.5;
      if (o) P.bots.push(makeBot(o.b, 415, y, PI + 0.35, o, o.name));
      ctx.setTransform(k, 0, 0, k, 0, 0); drawScene(ctx, P, fs, t);
      ctx.font = mono(fs * 1.1); ctx.textAlign = 'center'; ctx.fillStyle = 'rgba(244,240,230,0.9)';
      ctx.fillText(weightOf(build) + ' g', 185, ly);
      if (o) ctx.fillText(weightOf(o.b) + ' g', 415, ly);
      else {
        ctx.save(); ctx.translate(415, y); ctx.rotate(0.35); ctx.setLineDash([6, 6]); ctx.strokeStyle = 'rgba(244,240,230,0.35)'; ctx.lineWidth = 2;
        rr(ctx, -R * sc * 0.9, -R * sc * 0.84, R * sc * 1.9, R * sc * 1.68, 12); ctx.stroke(); ctx.restore(); ctx.setLineDash([]);
        ctx.font = display(fs * 4); ctx.fillStyle = 'rgba(244,240,230,0.4)'; ctx.fillText('?', 415, y + fs * 1.4);
        ctx.font = mono(fs); ctx.fillStyle = 'rgba(244,240,230,0.75)'; ctx.fillText('MYSTERY OPPONENT', 415, ly);
      }
      ctx.font = display(fs * 2.2); ctx.fillStyle = 'rgba(255,176,0,0.85)'; ctx.fillText('VS', 300, y + 7);
    }

    /* ---------- loop */
    function go() { if (!raf) { last = performance.now(); acc = 0; raf = requestAnimationFrame(frame); } }
    function halt() { if (raf) cancelAnimationFrame(raf); raf = 0; }
    function frame(now) {
      raf = 0;
      if (!G || paused || mode !== 'fight') return;
      var dt = M.min(0.05, M.max(0, (now - last) / 1000)), n = 0;
      last = now; acc += dt * speed;
      while (acc >= STEP && n < 12 * speed) { step(G, STEP); acc -= STEP; n++; }
      if (n >= 12 * speed) acc = 0;
      G.ev.forEach(function (e) { comm(e.say, e.prio); });
      G.ev.length = 0;
      draw();
      hudT += dt; if (hudT > 0.07) { hudT = 0; hud(); }
      overlay(G.cd > 0 ? String(M.ceil(G.cd)) : G.over ? { win: 'Victory', lose: 'Defeat', draw: 'Draw' }[G.over.r] : G.t < 0.7 ? 'Fight!' : '', G.over ? 'is-' + G.over.r : '');
      if (G.over && (endT += dt * speed) > 1.8) { finish(); return; }
      if (!vis && G.cd <= 0 && now - launchedAt > 1500) { pause('away'); return; }
      raf = requestAnimationFrame(frame);
    }
    function pause(why) {
      if (mode !== 'fight' || paused || !G || G.over) return;
      paused = why || 'user'; halt(); clearKeys(); hud();
      ovText = null; ov.hidden = false; ov.className = 'rs-arena__overlay is-pause'; big.hidden = true; pz.hidden = false;
      txt('[data-rs-why]', why === 'away' ? 'We paused while the arena was off screen.' : why === 'hidden' ? 'We paused while you were in another tab.' : '');
      comm('Paused. ' + (touch ? 'Tap Resume' : 'Press P, Esc or Resume') + ' to carry on.', 1);
      if (why === 'user') q('[data-rs-act="resume"]').focus({ preventScroll: true });
      txt('[data-rs-act="pause"]', 'Resume');
    }
    function resume() {
      if (!paused) return;
      paused = ''; ovText = null; ov.hidden = true;
      txt('[data-rs-act="pause"]', 'Pause');
      stage.focus({ preventScroll: true });
      comm('Back in it.', 1); go();
    }
    function finish() {
      halt(); setMode('debrief'); overlay(''); debrief(); shop();
      q('[data-rs-result]').focus();
    }
    function quit() {
      halt(); paused = ''; G = null; ov.hidden = true; ovText = null; setMode('build'); update();
      comm('Back in the build bay.', 1);
      var f = q('input[name="drive"]:checked'); if (f) f.focus({ preventScroll: true });
      (q('[data-rs-panel]') || form).scrollIntoView({ block: 'start', behavior: calm() ? 'auto' : 'smooth' });
    }

    /* ---------- debrief + shop */
    function tip(p, r, how) {
      if (how === 'pit' && r === 'lose') return 'Once the pit opens, keep it behind your opponent, not behind you. 4WD grip makes you much harder to shove.';
      if (r !== 'win' && spinner(p) && p.hits < 3) return 'Spin the weapon up before you engage. Spinners need a second or two to reach full speed.';
      if (r !== 'win' && p.taken > 45 && p.ar.id !== 'thick') return 'You soaked up a lot of damage. The thick TPU shell shrugs off hits, if you can find the grams.';
      if (p.e < 0.25) return 'Your battery ran low. A 300 mAh pack keeps the weapon spinning for the whole match.';
      if (r === 'win') return sel.diff === 'veteran' ? 'Beating a Veteran is no fluke. Time to build it for real.' : 'Clean win. Try Veteran next: it drives sharper and hunts for the pit.';
      return 'Each weapon plays very differently. Try another one, or move weight between drive and armour.';
    }
    function debrief() {
      var p = G.bots[0], o = G.bots[1], r = G.over.r, how = G.over.how, res = q('[data-rs-result]'), k;
      res.textContent = { win: 'Victory', lose: 'Defeat', draw: 'Draw' }[r]; res.className = 'rs-arena__result is-' + r;
      txt('[data-rs-how]', how === 'ko' ? (r === 'win' ? 'Knockout: ' + o.name + ' is done' : r === 'lose' ? 'Knocked out by ' + o.name : 'Double knockout') :
        how === 'pit' ? (r === 'win' ? o.name + ' went into the pit' : r === 'lose' ? 'You went into the pit' : 'Both robots went into the pit') :
        'Judges\u2019 decision on damage, ' + M.round(p.dealt) + ' to ' + M.round(o.dealt));
      txt('[data-rs-how2]', 'vs ' + o.name + ', ' + (G.diffId === 'veteran' ? 'Veteran' : 'Rookie') + (G.auto ? ', auto-pilot' : ''));
      var v = { hits: p.hits, dealt: M.round(p.dealt), taken: M.round(p.taken), top: (p.top * KMH).toFixed(1) + ' km/h', hp: M.round(p.hp) + '%', time: mmss(G.over.t) };
      for (k in v) txt('[data-rs-d="' + k + '"]', v[k]);
      txt('[data-rs-tip]', tip(p, r, how));
    }
    function shop() {
      var box = q('[data-rs-cats]'), el = q('[data-rs-shop]');
      if (!box || !el) return;
      var b = G.bots[0].b, plan = shopPlan(b), base = cfg.root + 'collections/', parts = base + encodeURIComponent(cfg.parts), arms = base + encodeURIComponent(cfg.armour);
      el.hidden = false; txt('[data-rs-shopw]', weightOf(b));
      box.innerHTML = plan.map(function (c, i) {
        return '<section class="rs-arena__cat"><h4 class="rs-arena__cat-h"><span>' + c.t + '</span> ' + esc(c.sub) + '</h4><div class="rs-arena__cards" data-rs-cat="' + i + '"><p class="rs-arena__loading">Checking the shelves\u2026</p></div></section>';
      }).join('');
      function none() { return null; }
      Promise.all([load(cfg.root, cfg.parts).catch(none), load(cfg.root, cfg.armour).catch(none)]).then(function (res) {
        var used = {};
        plan.forEach(function (c, i) {
          var el = q('[data-rs-cat="' + i + '"]'), src = c.arm ? res[1] : res[0], link = c.arm ? arms : parts, list = [];
          if (!el) return;
          if (c.note) { el.innerHTML = '<p class="rs-arena__catnote">' + esc(c.note) + '</p><a class="rs-link" href="' + esc(arms) + '">Shop TPU for the shell &rarr;</a>'; return; }
          if (src) c.specs.forEach(function (s) { list = list.concat(pick(src, s, used)); });
          el.innerHTML = list.length ? '<div class="rs-arena__row">' + list.map(function (p) { return card(p, cfg.root); }).join('') + '</div>' :
            '<p class="rs-arena__catnote">' + (src ? 'Nothing matched on the shelf right now.' : 'We couldn\u2019t load the shelf just now.') + '</p><a class="rs-link" href="' + esc(link) + '">Browse the range &rarr;</a>';
          $$('img', el).forEach(function (im) { /* missing photo: show a branded tile instead of a broken image */
            im.addEventListener('error', function () { var s = d.createElement('span'); s.className = 'rs-arena__noimg'; s.setAttribute('aria-hidden', 'true'); im.replaceWith(s); });
          });
        });
      });
    }

    /* ---------- input: keys only while the arena has focus and a match is on */
    var KEYS = { ArrowUp: 'up', KeyW: 'up', ArrowDown: 'down', KeyS: 'down', ArrowLeft: 'left', KeyA: 'left', ArrowRight: 'right', KeyD: 'right' };
    function clearKeys() { input.up = input.down = input.left = input.right = 0; }
    function isTouch() { touch = true; sec.classList.add('is-touch'); }
    stage.addEventListener('keydown', function (e) {
      if (mode !== 'fight' || !G || e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.code === 'KeyP' || e.key === 'Escape') { e.preventDefault(); if (paused) resume(); else pause('user'); return; }
      if (paused || G.over) return;
      var k = KEYS[e.code];
      if (k) { input[k] = 1; e.preventDefault(); }
      else if (e.code === 'Space') { e.preventDefault(); if (!e.repeat) input.fire = true; }
    });
    stage.addEventListener('keyup', function (e) { var k = KEYS[e.code]; if (k) input[k] = 0; });
    stage.addEventListener('blur', clearKeys);
    stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') isTouch(); });
    sec.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-rs-act]'), a = b && b.getAttribute('data-rs-act');
      if (!a) return;
      if (a === 'resume') resume();
      else if (a === 'quit' || a === 'rebuild') quit();
      else if (a === 'pause') { if (paused) resume(); else pause('user'); }
      else if (a === 'rematch' && G) start(G.oppId);
      else if (a === 'new' && G) start(pickOpp(G.oppId));
      else if (a === 'fire' && e.detail === 0 && G) input.fire = true; /* keyboard activation; pointers fire on pointerdown */
    });
    var fire = q('[data-rs-act="fire"]');
    if (fire) {
      fire.addEventListener('pointerdown', function (e) { if (mode === 'fight' && !paused) input.fire = true; if (e.pointerType === 'touch') isTouch(); });
      fire.addEventListener('mousedown', function (e) { e.preventDefault(); }); /* keep keyboard focus on the arena */
    }
    if (au2) au2.addEventListener('change', function () {
      var a1 = q('input[name="auto"]');
      sel.auto = au2.checked; if (a1) a1.checked = au2.checked;
      if (G) { G.auto = au2.checked; clearKeys(); input.sm = 0; }
      comm(au2.checked ? 'Auto-pilot on. Sit back and watch.' : 'Auto-pilot off. You have the controls.', 1);
      if (!au2.checked && !touch) stage.focus({ preventScroll: true });
    });
    var stick = q('[data-rs-stick]');
    if (stick) {
      var knob = stick.firstElementChild, sid = null;
      var stickMove = function (e) {
        var r = stick.getBoundingClientRect(), dx = e.clientX - r.left - r.width / 2, dy = e.clientY - r.top - r.height / 2, max = r.width * 0.34, m = M.hypot(dx, dy);
        if (m > max) { dx *= max / m; dy *= max / m; }
        if (knob) knob.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        input.sx = dx / max; input.sy = dy / max; input.sm = M.min(1, m / max);
      };
      stick.addEventListener('pointerdown', function (e) {
        e.preventDefault(); sid = e.pointerId; isTouch();
        try { stick.setPointerCapture(e.pointerId); } catch (x) { /* synthetic events */ }
        stickMove(e);
      });
      stick.addEventListener('pointermove', function (e) { if (e.pointerId === sid) stickMove(e); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
        stick.addEventListener(t, function (e) { if (e.pointerId !== sid) return; sid = null; input.sm = input.sx = input.sy = 0; if (knob) knob.style.transform = ''; });
      });
    }
    if (touch) sec.classList.add('is-touch');

    /* ---------- never run off screen or in a background tab */
    var io = null, ro = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { vis = en[en.length - 1].intersectionRatio >= 0.2; }, { threshold: [0, 0.2, 0.5] });
      io.observe(stage);
    }
    function onVis() { if (d.hidden) pause('hidden'); }
    d.addEventListener('visibilitychange', onVis);
    if ('ResizeObserver' in window) { ro = new ResizeObserver(resize); ro.observe(stage); } else window.addEventListener('resize', resize);
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!raf) draw(); });

    readForm(); setMode('build'); update(); resize();
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { if (size) { drawBg(bgx); draw(); } });

    return { /* test hooks */
      el: sec,
      get game() { return G; }, get mode() { return mode; }, get paused() { return paused; }, get build() { return build; },
      setSpeed: function (n) { speed = M.max(0.25, +n || 1); },
      hold: function (on) { if (on) halt(); else if (G && mode === 'fight' && !paused) go(); }, /* freeze a frame for screenshots */
      launch: launch, pause: pause, resume: resume,
      destroy: function () { halt(); if (io) io.disconnect(); if (ro) ro.disconnect(); d.removeEventListener('visibilitychange', onVis); G = null; }
    };
  }

  /* ------------------------------------------------------------------ boot */
  function init(root) {
    $$('[data-rs-arena]', root).concat(root && root.matches && root.matches('[data-rs-arena]') ? [root] : []).forEach(function (sec) {
      if (sec.rsArena) return;
      var a = Arena(sec);
      if (a) { sec.rsArena = a; instances.push(a); }
    });
  }
  window.RSArena = {
    init: init, instances: instances, PARTS: PARTS, OPPS: OPPS, CONTROL_G: CONTROL_G,
    weightOf: weightOf, statsOf: statsOf, fixes: fixes, allBuilds: allBuilds, shopPlan: shopPlan, pick: pick,
    sim: { newGame: newGame, step: step, oppBy: oppBy }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:section:unload', function (e) {
    $$('[data-rs-arena]', e.target).forEach(function (s) { if (s.rsArena) { s.rsArena.destroy(); instances.splice(instances.indexOf(s.rsArena), 1); s.rsArena = null; } });
  });
})();
